module.exports = __webpack_public_path__ + "img/cw1.168fd318.jpg";